import { FontAwesomeIcon } from "@fortawesome/react-fontawesome"
import { useCardWidget } from "../../Hooks/Features/ProjectDashboard/useCardWidget"

const CardsWidget = () => {

    const { cardsData } = useCardWidget();

    return (
        <div className="row w100">
            <div className="col-lg-3 col-sm-6 col-12 mt-1">
                <div className="card-container" style={{ borderTop: `5px solid #75bef8` }}>
                    <div className="d-flex gap-2">
                        <div className="w20 d-flex justify-content-center align-items-center"  ><span className="pro-widget-icon bg-project-icon"><FontAwesomeIcon icon="fas fa-folder" style={{ width: "60%", height: "60%", color: "#75bef8" }} /></span></div>
                        <div>
                            <span style={{ fontSize: "16px", fontWeight: "500" }}>Total Projects</span>
                            <h3 style={{ fontWeight: "700" }}>{cardsData?.card_projects?.total || 0}</h3>
                            <p className="widget-inner-lable">{cardsData?.card_projects?.label}&ensp;</p>
                        </div>
                    </div>
                </div>
            </div>
            <div className="col-lg-3 col-sm-6 col-12 mt-1">
                <div className="card-container" style={{ borderTop: `5px solid #6372c3` }}>
                    <div className="d-flex gap-2">
                        <div className="w20 d-flex justify-content-center align-items-center"  ><span className="pro-widget-icon bg-employee-icon"><FontAwesomeIcon icon="fa-solid fa-users" style={{ width: "60%", height: "60%", color: "#6372c3" }} /></span></div>
                        <div>
                            <span style={{ fontSize: "16px", fontWeight: "500" }}>Total Employees</span>
                            <h3 style={{ fontWeight: "700" }}>{cardsData?.card_employees?.total_employee || 0}</h3>
                            <p className="widget-inner-lable"><span className="text-success">Billable: {cardsData?.card_employees?.billable_employee} </span><span className="mx-2 text-danger">Non-Billable: {cardsData?.card_employees?.non_billable_employee}</span>&ensp;</p>
                        </div>
                    </div>
                </div>
            </div>
            <div className="col-lg-3 col-sm-6 col-12 mt-1">
                <div className=" card-container" style={{ borderTop: `5px solid #f9ae61` }}>
                    <div className="d-flex gap-2">
                        <div className="w20 d-flex justify-content-center align-items-center"  ><span className="pro-widget-icon bg-client-icon"><FontAwesomeIcon icon="fa-solid fa-handshake" style={{ width: "60%", height: "60%", color: "#f9ae61" }} /></span></div>
                        <div>
                            <span style={{ fontSize: "16px", fontWeight: "500" }}>Total Clients</span>
                            <h3 style={{ fontWeight: "700" }}>{cardsData?.card_clients?.total_clients || 0}</h3>
                            <p className="widget-inner-lable"> &ensp;</p>
                        </div>
                    </div>
                </div>
            </div>
            <div className="col-lg-3 col-sm-6 col-12 mt-1">
                <div className="card-container" style={{ borderTop: `5px solid #61beb5` }}>
                    <div className="d-flex gap-2">
                        <div className="w20 d-flex justify-content-center align-items-center"  ><span className="pro-widget-icon bg-worklog-icon"><FontAwesomeIcon icon="fa-solid fa-clock" style={{ width: "60%", height: "60%", color: "#61beb5" }} /></span></div>
                        <div>
                            <span style={{ fontSize: "16px", fontWeight: "500" }}>Total Worklogs</span>
                            <h3 style={{ fontWeight: "700" }}>{cardsData?.card_worklogs?.total_hours || 0}</h3>
                            <p className="widget-inner-lable">Avg. hours/day: {cardsData?.card_worklogs?.total_avg_hours_per_day}&ensp;</p>
                        </div>
                    </div>
                </div>
            </div>

        </div>
    )
}

export default CardsWidget